let parallaxElements = [];
let frameRequested = false;
let listenersAttached = false;

const reducedMotion = () =>
  window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

function speedFor(element) {
  const parsed = Number.parseFloat(element.dataset.parallaxSpeed || "0");
  return Number.isFinite(parsed) ? clamp(parsed, -0.12, 0.12) : 0;
}

function updateParallax() {
  frameRequested = false;
  parallaxElements = parallaxElements.filter((element) => element.isConnected);

  const motionReduced = reducedMotion();
  const viewportCenter = window.innerHeight / 2;

  parallaxElements.forEach((element) => {
    const motionDisabled = Boolean(element.closest('[data-motion="off"]'));

    if (motionReduced || motionDisabled) {
      element.style.translate = "";
      return;
    }

    const rect = element.getBoundingClientRect();
    const distanceFromCenter = rect.top + rect.height / 2 - viewportCenter;
    const offset = clamp(-distanceFromCenter * speedFor(element), -96, 96);
    element.style.translate = `0 ${offset.toFixed(1)}px`;
  });
}

function scheduleUpdate() {
  if (frameRequested) return;
  frameRequested = true;
  window.requestAnimationFrame(updateParallax);
}

export function refreshParallax(root = document) {
  root.querySelectorAll("[data-parallax-speed]").forEach((element) => {
    if (!parallaxElements.includes(element)) parallaxElements.push(element);
  });

  if (!listenersAttached) {
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    listenersAttached = true;
  }

  scheduleUpdate();
}
